export default "__VITE_ASSET__CrdC3Mgp__"